<mat-toolbar class="transversal-toolbar">
	<button type="button" mat-icon-button (click)="menuOpened = !menuOpened" class="transversal-header-menu" title="Menu">
		<mat-icon svgIcon="md:menu"></mat-icon>
	</button>

	<mat-icon class="transversal-header-arcelormittal" svgIcon="am_with_text"></mat-icon>
	<h1 class="transversal-header-steeluser" translate>transversal.steeluser</h1>

	<mat-form-field class="transversal-header-search" appearance="outline" subscriptSizing="dynamic">
		<mat-icon svgIcon="search" class="transversal-header-search-icon" matPrefix></mat-icon>
		<input [placeholder]="'search.placeholder' | translate" matInput type="text" spellcheck="false"
			autocomplete="off"
			[formControl]="searchTextControl" />
		<button type="button" *ngIf="searchTextControl.value" matSuffix mat-icon-button
			(click)="searchTextControl.reset(''); evtGlobalSearchClosed()" tabindex="-1">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</mat-form-field>
	<div class="transversal-header-user-icons">
		<button type="button" mat-button #userHeader class="transversal-header-user" (click)="openUserCardPopup()">
			<div class="transversal-header-user-information">
				<span class="transversal-header-user-name">
					<span class="transversal-user-simulation" *ngIf="user.isSimulating()">{{ 'transversal.simulation-of' | translate }}&ngsp;</span>
					{{ user.firstname }} {{ user.lastname }}
				</span>
				<span class="transversal-header-user-organization">
					<span class="transversal-user-simulation" *ngIf="user.isDelegating()">{{ 'transversal.delegated-to' | translate }}&ngsp;</span>
					<span [matTooltip]="'access.organization.name' | translate" class="organization-name-underline">
						{{ user.currentVisibility.organizationName }}
					</span>
				</span>
			</div>
			<mat-icon iconPositionEnd svgIcon="header_profile" class="transversal-sidenav-personal-icon"></mat-icon>
		</button>
		<button type="button" mat-icon-button #helpButton class="transversal-header-help-link" (click)="openHelpCardPopup()" [matTooltip]="'help.documents' | translate">
			<mat-icon class="transversal-header-help-icon" svgIcon="wiki_help"></mat-icon>
		</button>
	</div>
</mat-toolbar>
<mat-sidenav-container class="transversal-sidenav-container">
	<mat-sidenav class="transversal-sidenav" [opened]="menuOpened" [mode]="mobileQuery.matches ? 'over' : 'side'"
		(openedChange)="onMenuOpenedChange($event)">
		<mat-nav-list>
			<div class="transversal-sidenav-personal-card" [attr.title]="'menu.settings' | translate">
				<a mat-ripple class="transversal-sidenav-personal-card-data" [routerLink]="['/user/card/self/settings/general']">
					<mat-icon svgIcon="header_profile" class="transversal-sidenav-personal-icon"></mat-icon>
					<span class="transversal-user-simulation" *ngIf="user.isSimulating()">{{ 'transversal.simulation-of' | translate }}&ngsp;</span>
					<span class="personal-card-organization-card-data">{{ user.firstname }} {{ user.lastname }}</span>
				</a>
				<a mat-ripple class="transversal-sidenav-personal-card-data personal-card-organization-card-data"
					[routerLink]="['/user/organization', this.user.currentVisibility.organizationId, 'details']">
					<span class="transversal-user-simulation" *ngIf="user.isDelegating()">{{ 'transversal.delegated-to' | translate }}&ngsp;</span>
					{{user.currentVisibility.organizationName}}
				</a>
				<button type="button" mat-button color="accent" (click)="changeSimulatedUser()" *ngIf="user.isSimulating()"><span
						translate>settings.change-simulated-user</span></button>
				<button type="button" mat-button color="accent" (click)="logout()"><span translate>settings.logout</span></button>
			</div>
			<a mat-list-item [routerLink]="['/home']" routerLinkActive="item-selected"><span
					class="transversal-sidenav-list-item-root" translate>transversal.home</span></a>
			<p mat-list-item class="transversal-list-item-category"
			*ngIf="user.hasService('EOFFR') || user.hasService('PORDT') || user.hasService('QUAPP')"><span class="text-transform-uppercase"
				 translate>transversal.dashboard.plural</span></p>
			<a mat-list-item [routerLink]="['/offer/dashboard']" routerLinkActive="item-selected"
			*ngIf="user.hasService('EOFFR')"><span class="transversal-sidenav-list-item-root"
				translate>eoffer.offer</span></a>
			<a mat-list-item [routerLink]="['/order-tracking/dashboard']" *ngIf="user.hasService('PORDT')"
				routerLinkActive="item-selected">
				<span class="transversal-sidenav-list-item-root" translate>transversal.order.delivery</span></a>
			<a mat-list-item [routerLink]="['/ecall-off/dashboard']" *ngIf="user.hasService('PCALL')"
				routerLinkActive="item-selected">
				<span class="transversal-sidenav-list-item-root" translate>ecall-off.call-off-follow-up</span></a>
				<a mat-list-item [routerLink]="['/ecall-off/ecall/list']" *ngIf="user.hasService('PCALL')" routerLinkActive="item-selected" class="transversal-sidenav-list-item-child"><span class="transversal-sidenav-list-item-child-span" translate>ecall-off.my-ecalls</span></a>
				<a mat-list-item [routerLink]="['/quality-issues/dashboard']" routerLinkActive="item-selected"
				*ngIf="user.hasService('QUAPP') || user.hasService('PGNTE')"><span class="transversal-sidenav-list-item-root"
					translate>eoffer.product.plural</span></a>
			<a mat-list-item [routerLink]="['/guarantee-requests/list']" *ngIf="user.hasService('PGNTE')" routerLinkActive="item-selected" class="transversal-sidenav-list-item-child"><span class="transversal-sidenav-list-item-child-span" translate>guarantee.service.requests</span></a>
			<a mat-list-item [routerLink]="['/auction/dashboard']" routerLinkActive="item-selected"
				*ngIf="user.hasService('PAUCT')">
				<span class="transversal-sidenav-list-item-root" translate>auctions.menu</span>
			</a>
			<a mat-list-item [routerLink]="['/auction/bids']" *ngIf="user.hasService('PAUCT')"
				routerLinkActive="item-selected" class="transversal-sidenav-list-item-child"><span
					class="transversal-sidenav-list-item-child-span" translate>auction.my.auction.bids</span></a>
			<p mat-list-item class="transversal-list-item-category"
				*ngIf="(user.hasService('EOFFR') && user.isOfferValidator()) || (user.hasService('QUAPP') && (user.isClaimValidator() || user.isClaimDetector()) || user.hasService('EORDR')) || user.hasService('ND4ST') || user.hasService('PGNTE') || user.hasService('PCALL') || user.hasService('PAUCT')"><span class="text-transform-uppercase"
				translate>transversal.services</span></p>
			<a mat-list-item  routerLinkActive="item-selected" [routerLink]="['/home/sales-services']"
				*ngIf="(user.hasService('EOFFR') && user.isOfferValidator()) || user.hasService('EORDR') || user.hasService('ND4ST') || user.hasService('PFEAS')"
				><span class="transversal-sidenav-list-item-root" translate>menu.sales-services</span></a>
			<a mat-list-item  routerLinkActive="item-selected" [routerLink]="['/home/order-services']"
				*ngIf="user.hasService('PCALL')"><span class="transversal-sidenav-list-item-root" translate>menu.order-services</span></a>
			<a mat-list-item [routerLink]="['/home/quality-services']" routerLinkActive="item-selected"
				*ngIf="(user.hasService('QUAPP') && (user.isClaimValidator() || user.isClaimDetector())) || user.hasService('PGNTE') || user.hasService('PAUCT')"><span class="transversal-sidenav-list-item-root" translate>menu.product-services</span></a>
			<p mat-list-item class="transversal-list-item-category"
			*ngIf="user.hasService('EOFFR') || user.hasService('PORDT') || user.hasService('QUAPP') || user.hasService('PDOCS') || user.hasService('ORGMG') || user.hasService('PFAST')"><span class="text-transform-uppercase"
					translate>transversal.data-center.plural</span></p>
			<a mat-list-item [routerLink]="['/home/all-datacenter']" routerLinkActive="item-selected"
			*ngIf="user.hasService('EOFFR') || user.hasService('PORDT') || user.hasService('QUAPP') || user.hasService('PDOCS') || user.hasService('ORGMG') || user.hasService('PFAST')">
				<span class="transversal-sidenav-list-item-root" translate>datacenter.all-data-center</span></a>
		</mat-nav-list>
		<mat-nav-list class="transversal-sidenav-footer">
			<a mat-list-item href="mailto:ebusiness.support@arcelormittal.com"
				class="transversal-sidenav-footer-list-item-child">
				<mat-icon matListItemIcon class="transversal-sidenav-footer-icon" svgIcon="mail_box"></mat-icon>
				<span matListItemTitle class="transversal-sidenav-footer-text" translate>contact.us</span>
			</a>
			<a mat-list-item [routerLink]="['/legal-informations']" class="transversal-sidenav-footer-list-item-child">
				<mat-icon matListItemIcon class="transversal-sidenav-footer-icon" svgIcon="document_box"></mat-icon>
				<span matListItemTitle class="transversal-sidenav-footer-text" translate>term.policy</span>
			</a>
			<a mat-list-item [routerLink]="['/guarantee-documents']" class="transversal-sidenav-footer-list-item-child">
				<mat-icon matListItemIcon class="transversal-sidenav-footer-icon" svgIcon="document_box"></mat-icon>
				<span matListItemTitle class="transversal-sidenav-footer-text" translate>guarantee.documents</span>
			</a>
			<a mat-list-item [href]="oldSteelUserUrl + '/homepage/managehomepage/displayhometabs.action?stay=true'"
				*ngIf="user.hasServiceParameterEqualsTo('MVPPA', 'withOldSteeluserLink', 'True')"
				class="transversal-sidenav-footer-list-item-child">
				<mat-icon matListItemIcon class="transversal-sidenav-footer-icon" svgIcon="document_box"></mat-icon>
				<span matListItemTitle class="transversal-sidenav-footer-text" translate>transversal.go-back-to-old-steeluser</span>
			</a>
		</mat-nav-list>
	</mat-sidenav>
	<mat-sidenav-content [class.copo-navigation-invisible]="navigationLoading">
		<router-outlet></router-outlet>
	</mat-sidenav-content>
	<mat-sidenav-content [class.copo-navigation-invisible]="!navigationLoading">
		<copo-loading-spinner></copo-loading-spinner>
	</mat-sidenav-content>
</mat-sidenav-container>
<ng-template #userCardContent>
	<div class="user-card-popup" @bubbleAnimation>
		<div class="user-card-popup-user">
			<mat-icon class="user-card-pop-icon" svgIcon="header_profile_big"></mat-icon>
			<span class="user-card-popup-name">{{ user.firstname }} {{ user.lastname }}</span>
		</div>
		<div class="user-card-popup-information">
			<div class="user-card-popup-organizations">
				<span class="user-card-popup-label" translate>settings.organisation</span>
				<span class="user-card-popup-value">
					<ng-container *ngIf="user.isDelegating()">
						<span class="transversal-user-simulation" translate>transversal.delegated-to</span>&ngsp;
					</ng-container>
					<a class="organization-name" [matTooltip]="'access.organization.name' | translate"  (click)="cleanWhenLeaving()" [routerLink]="['/user/organization', this.user.currentVisibility.organizationId, 'details']">{{ user.currentVisibility.organizationName
						}}</a>
				</span>
			</div>
			<div class="user-card-popup-organizations">
				<span class="user-card-popup-label" translate>settings.supplier</span>
				<span class="user-card-popup-value">{{ user.currentVisibility.supplierName }}</span>
			</div>
			<div class="user-card-popup-settings">

				<a mat-button [matTooltip]="'access.user.card' | translate"  color="accent" (click)="cleanWhenLeaving()" [routerLink]="['/user/card/self/settings/general']"><span class="organization-name-underline"
						translate>settings.account</span></a>
				<button type="button" mat-button color="accent" (click)="changeSimulatedUser()" *ngIf="user.isSimulating()"><span
						translate>settings.change-simulated-user</span></button>
				<button type="button" mat-button color="accent" (click)="changeDelegatedOrganization()" *ngIf="user.isDelegating()">
					<span translate>settings.delegation.changement</span>
				</button>
				<button type="button" mat-button color="accent" (click)="logout()"><span translate>settings.logout</span></button>
			</div>
		</div>
	</div>
</ng-template>